const CATEGORY_CLASS_MAP = {
  features: 'features',
  feature: 'features',
  effects: 'effects',
  effect: 'effects',
  text: 'text',
  media: 'media',
  shape: 'shape',
  component: 'components',
  components: 'components',
  'visual component': 'components',
  'visual components': 'components',
};

const toCategoryClass = (value) => {
  if (typeof value !== 'string') return null;

  const normalized = value.trim().toLowerCase();
  if (!normalized) return null;

  return CATEGORY_CLASS_MAP[normalized] || normalized.replace(/\s+/g, '-');
};

export const getIconCategoryClass = (category) => {
  if (Array.isArray(category)) {
    for (const entry of category) {
      const resolved = toCategoryClass(entry);
      if (resolved) return resolved;
    }
    return 'misc';
  }

  return toCategoryClass(category) || 'misc';
};

export default getIconCategoryClass;